module.exports = __webpack_public_path__ + "img/ic_property_flat.406ec3e7.svg";